<div class="wchfs-chip-list-wrapper">
  <ng-content></ng-content>
</div>
